import { render } from "./Operacionais.vue?vue&type=template&id=024fa9c8&scoped=true"
import script from "./Operacionais.vue?vue&type=script&lang=js"
export * from "./Operacionais.vue?vue&type=script&lang=js"

import "./Operacionais.vue?vue&type=style&index=0&id=024fa9c8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-024fa9c8"]])

export default __exports__